function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSwirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 9305 8341",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1013,1415)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,207.429,240.251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,854.749C4.103,774.577 64.01,700.351 141.509,679.415C201.556,663.195 265.333,676.938 325.202,693.805C385.071,710.673 445.691,730.864 507.793,727.379C569.895,723.895 635.173,690.078 654.439,630.937C672.715,574.832 639.165,507.171 583.443,487.759C519.744,465.569 445.769,507.401 417.841,568.8C389.912,630.199 401.028,703.726 431.311,763.999C482.796,866.466 586.649,937.886 698.847,961.587C811.045,985.287 930.019,964.15 1033.5,914.73C1167.44,850.76 1280.62,734.512 1319.03,591.137C1357.45,447.761 1310.3,279.442 1189.47,193.233C1102.52,131.2 989.88,116.327 883.268,122.799C776.655,129.27 672.125,154.962 565.9,166.117C459.676,177.271 347.592,172.681 253.235,122.631C201.841,95.37 154.909,50.745 145.322,-6.636C135.734,-64.018 178.478,-130.538 236.638,-129.115",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(0,74,113)",
      strokeWidth: "89.66px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSwirl);
export default __webpack_public_path__ + "static/media/hero-swirl.00d9a488866df137b5b6af93267774a0.svg";
export { ForwardRef as ReactComponent };